import fetch from 'isomorphic-fetch';
import querystring from 'querystring';
import moment from 'moment';
import Spinner from '~/utils/spinner'
import Cookies from 'js-cookie';
import promise from 'bluebird';
import Auth from '@aws-amplify/auth';
import { AwsClient } from 'aws4fetch';
import _ from 'lodash';

if(window.crypto.subtle === undefined){
    console.warn(`Polyfilling window.crypto.subtle using Nodejs library!`);
    let Crypto = new CryptoShim.Crypto();
    window.crypto.subtle = Crypto.subtle;
}

promise.config({
    cancellation: true
})

export default async function fetch_v1(args) {
    let { url, method='get', data, content_type='application/json', spinner=false, credentials='same-origin'} = args;
    var qs = '';

    let options = {
        method: method.toUpperCase(),
        headers: {},
        credentials: credentials  // 'include', 'same-origin', 'omit'
    }

    options.headers = {
       'Accept': 'application/json',
       'Content-Type': content_type
    };

    let fetchFn = fetch;  // isomorphic-fetch
    await Auth.currentSession();  // refresh access token if necessary
    let authCredentials = await Auth.currentUserCredentials();
    if (authCredentials) {
        let { accessKeyId, secretAccessKey, sessionToken } = authCredentials;
        var client = new AwsClient({
            accessKeyId: accessKeyId,
            secretAccessKey: secretAccessKey,
            sessionToken: sessionToken,
            service: 'execute-api',
            region: authCredentials.cognito.config.region,  // us-east-1 for staging, us-west-2 for prod
            retries: 0
        });
        fetchFn = client.fetch.bind(client)
    }

    // if(__DEV__){
    //     console.log(url);
    //     console.log(data);
    //     console.warn('traceback'); // for seeing which function invoked fetch
    // }

    if(content_type === null){
        delete options.headers['Content-Type'];
        options.body = data;
    }else if(content_type.startsWith('application/json')){
        options.body = JSON.stringify(data);
    }else if(content_type.startsWith('application/x-www-form-urlencoded')){
        options.body = querystring.stringify(data);
    }else{
        console.warn(`WARNING: Unrecognized content_type argument "${content_type}"`);
        options.body = data;
    }

    if(method.toLowerCase() === 'get'){
        options.body = undefined;  // must be explicit undefined type for MS Edge GET request; not null
        qs = '?' + querystring.stringify(data);
    }

    if(spinner){
        Spinner.start()
    }

    var p = promise.resolve();
    p = promise.delay(500);

    return p.then(()=>{
        return fetchFn(url + qs, options);
    }).then(result => {
        console.log(result);
        if (result.status >= 200 && result.status < 300) {
            if(result.status == 204){
                return 204;  // HTTP 204 - NO CONTENT
            }
            return result.json();
        } else {
            let error = new Error(`request failed with status ${result.status}`);
            error.response = result;
            return result.json()
            .catch(e =>{
                console.warn('failed to parse response body as JSON');
                throw error;
            })
            .then(json => {
                console.error(json);
                error.data = json;
                error.message = _.get(error, ['data', 'message'], null) || _.get(error, ['data', 'messages'], null) || 'unknown error';
                if(Array.isArray(error.message)){
                    error.message = JSON.parse(JSON.stringify(error.message)).join(' ');
                }
                console.log(error.message);
                throw error;
            })
        }
    })
    .catch(error => {
        if(error.message.indexOf('importKey') >= 0){
            console.error(error);
            throw new Error('For this importKey error, you are likely browsing an insecure HTTP host which Chrome disables certain crypto modules for. Try adding the explicit host to this Chrome flag: chrome://flags/#unsafely-treat-insecure-origin-as-secure')
        }
        if(error.message.indexOf('Access-Control-Allow-Origin') >= 0){
            console.error(error);
            throw new Error('FYI: "Access-Control-Allow-Origin" errors could actually be an InvalidSignatureException response. View the Response in Network Tools and possibly right-click > copy as cURL command to paste and view the JSON response in a terminal.')
        }
        throw error;
    })
    .finally(()=>{
        if(spinner){
            Spinner.stop()
        }
    })
}